export const normalizeString = (dato) => {
  if (typeof dato === 'number') {
    return dato.toString();
  }
  if (typeof dato === 'string') {
    if (dato.substring(10, 11) === 'T' && dato.substring(23, 34) === 'Z') {
      const cdate = new Date(dato);
      return cdate.toLocaleString();
    } else {
      return dato;
    }
  }
  if (typeof dato === 'boolean') {
    return dato ? 'activo' : 'inactivo';
  }
};

export const normalizeDate = (date) => {
  const dd = date.getDate().toString().padStart(2, '0');
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const yyyy = date.getFullYear().toString();
  const formatDate = yyyy + '-' + mm + '-' + dd;
  return formatDate;
};

export const normalizeStateIns = (state) => {
  const enumState = {
    C: 'Creado',
    P: 'Proceso',
    A: 'Pendiente Autorizacion',
    AP: 'Autorizacion Proceso',
    T: 'Terminado',
    I: 'Impreso',
    S: 'Asignada',
    CA: 'Cancelado',
    PE: 'Pendiente',
    PA: 'Pagado',
    pending: 'Pendiente',
    in_progress: 'En Proceso',
    resolved: 'Resuelto',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    urgent: 'Urgente',
  };
  return enumState[state] || state;
};

export const generalNormalize = (data) => {
  let text = '';
  text = normalizeString(data);
  text = normalizeStateIns(text);
  return text;
};

export const basetoblob = async (type, base64) => {
  const base64Data = base64;
  const base64Response = await fetch(`${type}${base64Data}`);
  const blob = await base64Response.blob();
  return blob;
};

export const getBase64 = async (imageFile, name = imageFile.name) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = function () {
        // Calculate new dimensions while maintaining the original aspect ratio
        let newWidth = img.width;
        let newHeight = img.height;

        //if (img.width > maxWidth) {
        //newWidth = maxWidth;
        newHeight = img.height * 0.8;
        //}

        //if (newHeight > maxHeight) {
        //newHeight = maxHeight;
        newWidth = img.width * 0.8;
        //}

        // Create a canvas element
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set the canvas dimensions to the new dimensions
        canvas.width = newWidth;
        canvas.height = newHeight;

        // Draw the image on the canvas with the new dimensions
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        // Convert the canvas content to base64 with specified quality
        const resizedBase64 = canvas.toDataURL('image/jpeg', 0.8);

        // resolve(resizedBase64);
        resolve({
          base64: resizedBase64,
          name: name,
        });
      };

      img.onerror = function (error) {
        reject(error);
      };
    };

    reader.onerror = function (error) {
      reject(error);
    };

    // Read the image file as a data URL
    reader.readAsDataURL(imageFile);
  });
  // return new Promise((resolve, reject) => {
  //   const reader = new FileReader();

  //   // Read the file as a data URL (base64)
  //   reader.readAsDataURL(file);

  //   // Handle the 'load' event when reading is complete
  //   reader.onload = () => {
  //     // The result is a data URL, but we only want the base64 part
  //     const base64String = reader.result;
  //     resolve({
  //       base64: base64String,
  //       name: file.name
  //     });
  //   };

  //   // Handle errors during reading
  //   reader.onerror = error => {
  //     reject(error);
  //   };
  // });
};

export const validPermission = (permissions, permission) => {
  const index = permissions.findIndex((per) => per.code === permission);
  return index >= 0;
};
